import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import SingleCategory from './SingleCategory';

function UserFinancesByCategory({month}) {

    // Get income categories
    // Create single category component
    const [incomeCategories, setIncomeCategories] = useState([]);
    const [expenseCategories, setExpenseCategories] = useState();

    useEffect(() => {

        try {
            const catRef = firestore.collection("budget-categories");
            catRef.orderBy("category").onSnapshot(({docs}) => {
                const categories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                const incomeCats = categories.filter(cat => {
                    return cat.type === "income";
                })
                const expenseCats = categories.filter(cat => {
                    return cat.type === "expense";
                })
                setIncomeCategories(incomeCats);
                setExpenseCategories(expenseCats);
            })
        } catch (error) {
            
        }

    }, [])


    return (
        <div className="row">
            <div className="col-md-6">
                {incomeCategories?.map((cat, index) => {
                    return (
                        <React.Fragment key={index}>
                            <SingleCategory categoryId={cat.id} type="income" categoryName={cat.category} month={month} />
                        </React.Fragment>
                    )
                })}
            </div>

            <div className="col-md-6">
                {expenseCategories?.map((cat, index) => {
                    return (
                        <React.Fragment key={index}>                          
                            <SingleCategory categoryId={cat.id} categoryName={cat.category} type="expense" month={month} />
                        </React.Fragment>
                    )
                })}
            </div>


        </div>
    )

}
export default UserFinancesByCategory